import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  actionGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    gap: theme.layout.gap.medium
  }
}))

function ActionGroup ({ children }) {
  const classes = useStyles()

  return (
    <div className={classes.actionGroup}>
      {children}
    </div>
  )
}

ActionGroup.propTypes = {
  children: PropTypes.node
}

export default ActionGroup
